import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { SmoothScrollbar } from 'gnos-scrollbar'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class EmptyContent extends Component {
    static propTypes = {
        openDialog: PropTypes.func.isRequired,
    }

    handleImportGroupMembers = () => {
        const { openDialog } = this.props

        openDialog('groupMembersImport')
    }

    render() {
        return (
            <SmoothScrollbar style={{ height: '100%' }} plugins={{ overscroll: false }}>
                <div className={'group-stack-empty-content'}>
                    <div className={'title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.title`} />
                    </div>
                    <div className={'import-title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importTitle`} values={{ br: <br /> }} />
                    </div>
                    <button className={'import-button'} onClick={this.handleImportGroupMembers}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importButton`} />
                    </button>
                    <div className={'animation-help-title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.animationHelpTitle`} />
                    </div>
                    <div className={'animation-help'} />
                </div>
            </SmoothScrollbar>
        )
    }
}
